import './index.scss';
import IZAdmin from './IZAdmin';

window.IZAdmin = new IZAdmin();

window.addEventListener('cresenity:loaded', function () {
    window.cresenity.setConfirmHandler((el, options, confirmCallback)=>{
        if($(el).hasClass('iz-delete')) {
            options.isDelete = true;
        }


        // eslint-disable-next-line no-alert
        window.cresenity.ui.emit('openConfirm', options);
        let callback = (confirmed = false) => {
            window.cresenity.ui.off('closeConfirmModal', callback);
            confirmCallback(confirmed);
        };
        window.cresenity.ui.on('closeConfirmModal', callback);
    });
});
